<div class="sidebar-ad"
     id="ads-banner-{{position()}}"
     data-track-content
     data-content-name="Skyscraper banner">
    @if (selected(); as banner) {
        <a [href]="banner.link || null"
           [target]="banner.link ? banner.target : null"
           [class.no-link]="!banner.link"
           data-content-target>
            <img
                    [src]="CDN + '/marketing-management/' + banner.image"
                    [alt]="banner.title || altText()"
                    class="ad-image"
                    data-content-piece
                    loading="eager">
        </a>
    }
</div>
